import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  NavbarText,
  Button,
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { userInfoSelector } from "store/selector/user";
import SwitchTheme from "components/theme";
import cn from "classnames";
import logo from "assets/image/logo.png";
import Support from "./support";
import AccountUser from "./accountUser";
import DigitalCurecny from "./digitalCurrencies";
import TopHeader from "./topHeader";
import { selectToken } from "store/selector/tokenStore";
import MobileMenu from "./mobileMenu";
import { isMobile } from "react-device-detect";
import "assets/styles/components/button.scss";
import "assets/styles/components/navbar.scss";
import "assets/styles/components/dropdown.scss";
import "assets/styles/components/header.scss";
import { COINNIK_MARKET_BLOG } from "configs/constants";

const Header = () => {
  const userInfo = useSelector(userInfoSelector);
  const { legalFirstName, legalLastName, email } = userInfo;
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const { t } = useTranslation();
  const location = useLocation();
  const tokens = useSelector(selectToken);

  useEffect(() => {
    const header: any = document.getElementById("myHeader");
    let scrollCallBack: any;
    if (header != null) {
      const sticky = header.offsetTop;
      scrollCallBack = window.addEventListener("scroll", () => {
        if (window.pageYOffset > sticky) {
          header.classList.add("sticky");
        } else {
          header.classList.remove("sticky");
        }
      });
    }
    return () => {
      window.removeEventListener("scroll", scrollCallBack);
    };
  }, [tokens]);
  // const [mail]=email?.split('@');

  return (
    <div>
      {isMobile ? (
        <Navbar dark className="w-100 position-fixed navbar navbar-index">
          <Container className="d-flex align-items-center justify-content-between ">
            <div className="nav-item ">
              <UncontrolledDropdown
                nav
                inNavbar
                className="list-unstyled dropdown-mobile"
              >
                <DropdownToggle nav className="p-0">
                  <i className="icon-menu " />
                </DropdownToggle>
                <MobileMenu />
              </UncontrolledDropdown>
            </div>
            <div className="nav-item">
              <Link to="/">
                <img src={logo} alt="logo" />
              </Link>
            </div>
            <div className="nav-item position-relative">
              <a href="tel://+982147612345">
                <i className="icon-phone bg-warning-one border-radius-2 p-1" />
              </a>
            </div>
          </Container>
        </Navbar>
      ) : (
        <>
          <TopHeader />
          <header id="myHeader">
            <Navbar expand="lg" dark className={cn("navbar shadow-lg ")}>
              <Container className="position-relative">
                <div className="nav-item">
                  <NavbarBrand>
                    <Link to="/">
                      <img src={logo} alt="logo" />
                    </Link>
                  </NavbarBrand>
                </div>
                <Nav navbar className={cn("w-100  nav-item--link ")}>
                  <NavItem>
                    <NavLink
                      className={
                        location.pathname === `/show-all-markets`
                          ? " nav-link--selected"
                          : ""
                      }
                      tag={Link}
                      to="/show-all-markets"
                    >
                      {t("Instant price")}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={
                        location.pathname === `/user-guide`
                          ? " nav-link--selected"
                          : ""
                      }
                      to={"/user-guide"}
                      tag={Link}
                    >
                      {t("user manual")}
                    </NavLink>
                  </NavItem>
                  <UncontrolledDropdown
                    nav
                    inNavbar
                    className="style-dropdown list-unstyled "
                  >
                    <DropdownToggle nav className="text-white">
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="ps-3"> {t("Digital currencies")}</span>
                        <i className="icon-chevron-down m-0" />
                      </div>
                    </DropdownToggle>
                    <DigitalCurecny />
                  </UncontrolledDropdown>
                  <NavItem>
                    <NavLink href="https://demoapp.coinnik.market/app/markets/BTC_TMN">
                      {t("Demo")}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href={COINNIK_MARKET_BLOG}>{t("Academy")}</NavLink>
                  </NavItem>
                </Nav>

                <div className="nav-item px-1 position-relative">
                  <UncontrolledDropdown
                    nav
                    inNavbar
                    className="style-dropdown list-unstyled"
                  >
                    <DropdownToggle nav>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="position-relative">
                           <span className="bubble" />
                          <i className="icon-phone" />
                        </div>
                        <span>{t("24-hour support")} </span>
                      </div>
                    </DropdownToggle>
                    <DropdownMenu className="py-3 px-1 w-100 ">
                      <Support />
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
                {legalFirstName || legalLastName || email ? (
                  <div className="nav-item position-relative">
                    <UncontrolledDropdown
                      nav
                      inNavbar
                      className="style-dropdown list-unstyled"
                    >
                      <DropdownToggle className="btn btn-warning" size="md">
                        <div className="d-flex  align-items-center">
                          <i className="icon-person " />
                          <span className="px-3 text-nowrap overflow-hidden dropdown-item-span">
                            {legalFirstName
                              ? legalFirstName
                              : email?.split("@")[0]}{" "}
                          </span>
                          <i className="icon-chevron-down" />
                        </div>
                      </DropdownToggle>
                      <AccountUser email={email} />
                    </UncontrolledDropdown>
                  </div>
                ) : (
                  <div className="nav-item d-flex flex-direction-row">
                    <Button
                      href="https://coinnik.market/app/user/register"
                      size="md"
                      color="warning"
                    >
                      <span>{t("sign up")}</span>
                    </Button>

                    <Button
                      className="me-2"
                      href="https://coinnik.market/app/user/login"
                      size="md"
                      color="warning"
                      outline
                    >
                      <span>{t("sign in")}</span>
                    </Button>
                  </div>
                )}
              </Container>
            </Navbar>
          </header>
        </>
      )}
    </div>
  );
};

export default Header;
